import React from 'react';

import { StyledTextField } from 'components/Input/styles';

import SearchAdornment from 'components/Adornment/SearchAdornment';

export interface MemberSearchFieldProps {
  value: string;
  onChange: (value: string) => void;
}

const MemberSearchField: React.FunctionComponent<MemberSearchFieldProps> = ({ value, onChange }) => (
  <StyledTextField
    placeholder="Search members..."
    size="medium"
    fullWidth
    value={value}
    onChange={(e) => onChange(e.target.value)}
    InputProps={{ startAdornment: <SearchAdornment /> }}
  />
);

export default MemberSearchField;
